import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParentEventListItemModel } from 'src/app/models/parent.event.list.item.model';
import { environment } from 'src/environments/environment';
import { EventAddModel } from '../models/event.add.model';

@Injectable()
export class EventService {

    constructor(private http: HttpClient) { }

    add = (model: EventAddModel) =>
        this.http.post(`${environment.apiUrl}/api/chief-editor/event/add`, model)

    getParentEventSelectItems = () =>
        this.http.get<Array<ParentEventListItemModel>>(`${environment.apiUrl}/api/chief-editor/event/parent-event-select-items`)
}
